import { IMetaDataServiceImpl } from '../services/metadata/imetadataserviceimpl';
import { IEntityMeta, IFieldMeta } from './imetadata';

export class DefaultMetaDataServiceImpl implements IMetaDataServiceImpl {
  promoteCompositeFields(): void {}

  findAssociatedEntity(field: IFieldMeta, knownEntities: Readonly<{ entityType: string; result: IEntityMeta }[]>): { entityType: string; result: IEntityMeta } | undefined {
    return knownEntities.find(e => e.entityType.toLowerCase() === field.path.toLowerCase());
  }

  getAssociatedEntity(field: IFieldMeta): string {
    return field.associatedEntity ?? field.path; // TODO: fix when invenias correct
  }

  updatePickerFieldMeta(): void {}
}
